import React from 'react'
import Item from './Item'
import {Grid} from "@mui/material"
import {motion, AnimatePresence} from 'framer-motion'

function MenuList({items}) {
  return (
    <motion.article layout initial={{opacity: 0, scale: 0}} animate={{opacity: 1, scale: 1, transition: {duration: 1, delay: 1}}}>
      <AnimatePresence>
      <Grid container spacing={2} sx={{paddingBottom: "80px"}}>
        
        {items.map((item) =><Item key={item.id} {...item}/>)}
        
    </Grid>
        
      </AnimatePresence>
    </motion.article>
  )
}

export default MenuList